import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { ClientStatementExpenseValidation } from 'uplisting-frontend/validations';

export default class ClientStatementExpenseRepositoryService extends BaseRepositoryService<
  ModelRegistry['client-statement-expense']
> {
  recordName = 'client-statement-expense';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = ClientStatementExpenseValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/client-statement-expense': ClientStatementExpenseRepositoryService;
  }
}
